import React, { useMemo, useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { CollapsibleOutline } from '@ann/web-components';
import { CardViewXContainer } from '../../MyWorkspace.styled';
import DocumentCard from '../../../../components/DocumentCard';
import { LoadMoreSection } from '../../../../components/LoadMoreSection';

const DocumentsList = observer(({
    documents,
    selectionStore,
    onShare,
    onDuplicate,
    onRename,
    onAssignAgent,
    onMove,
    onDelete,
    onOpenDocumentDetail,
    hasMore,
    isLoading,
    onLoadMore,
    onDropFiles,
    disabledActions = { download: true, rename: false, share: false, assignAgent: false, duplicate: false, move: false, delete: false },
    hiddenActions = { download: false, rename: false, share: false, assignAgent: false, duplicate: false, move: false, delete: false }
}) => {
    // ✅ Memoizar handler de preview de archivos para mantener referencia estable
    const handlePreviewFiles = useCallback((groups) => {
        console.log('Files to upload:', groups);
    }, []);

    // ✅ Memoizar tags para no recrear el array en cada render
    const documentTags = useMemo(() => [
        "Product team",
        "Guidelines",
        "Report",
        "Research",
        "Analysis",
        "Review",
        "Final",
    ], []);

    // ✅ Memoizar items de documentos para evitar recrear elementos en cada render
    const documentItems = useMemo(() => [
        <CollapsibleOutline.DragDrop key="drag-drop" alwaysVisible={false} />,
        ...documents.map((doc) => (
            <DocumentCard
                key={doc.document_uuid}
                id={doc.document_uuid}
                title={doc.name}
                owner={doc.owner_full_name}
                date={doc.created_at}
                status={doc.status}
                tags={documentTags}
                checked={doc.isSelected}
                isCheckboxable={doc.isHovered || doc.isSelected}
                onCheckboxChange={() => {
                    doc.setSelected(!doc.isSelected);
                    selectionStore.toggleDocumentSelection(doc.document_uuid);
                }}
                onMouseEnter={() => doc.setHover(true)}
                onMouseLeave={() => doc.setHover(false)}
                showHover
                size="medium"
                isUploading={doc.isUploading}
                uploadProgress={doc.uploadProgress}
                onShare={() => onShare(doc, 'document')}
                onDuplicate={() => onDuplicate(doc, 'document')}
                onAssignAgent={() => onAssignAgent(doc)}
                onRename={() => onRename(doc)}
                onMove={onMove ? () => onMove(doc.document_uuid) : undefined}
                onDelete={onDelete ? () => onDelete(doc) : undefined}
                onOpenDocumentDetail={() => onOpenDocumentDetail(doc)}
                disabledActions={disabledActions}
                hiddenActions={hiddenActions}
            />
        ))
    ], [documents, selectionStore, onShare, onDuplicate, onAssignAgent, onRename, onMove, onDelete, onOpenDocumentDetail, disabledActions, hiddenActions, documentTags]);

    return (
        <CollapsibleOutline
            itemCount={documents.length}
            title="Documents"
            defaultOpen={true}
            dragAndDrop={true}
            dragAndDropConfig={onDropFiles ? {
                onDrop: onDropFiles,
                width: 'auto',
                height: 'auto',
                persistPreview: true,
                onPreviewFiles: handlePreviewFiles
            } : undefined}
        >
            <CollapsibleOutline.Content>
                <CardViewXContainer>
                    {documentItems}
                    <LoadMoreSection
                        hasMore={hasMore}
                        isLoading={isLoading}
                        onLoadMore={onLoadMore}
                        skeletonType="document"
                    />
                </CardViewXContainer>
            </CollapsibleOutline.Content>
        </CollapsibleOutline>
    );
});

export default DocumentsList;